import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { OEComponents, OEUtils } from '@opportunityeducation/oe-web-common'
import { FormattedPlural } from '../../utils/FormattedPlural'
import {
  TextEl
} from './_Styled'
import { styledComposition } from '../../../utils/stylecomponents'
import { P2 } from '../../styled/typography/typography'

export default class TargetDateDueText extends Component {
  render () {
    return this.getElement()
  }

  getElement () {
    const {
      date,
      cssClass,
      styleComponent,
      textProps,
      display
    } = this.props

    let _el
    const differenceInDays = OEUtils.Time.getDifferenceInDaysToNow(moment(date).unix())
    const absDifferenceInDays = Math.abs(differenceInDays) // always returns positive number

    const TextElStyled = styledComposition(TextEl, styleComponent)

    // Requirements:
    // For dates that are 1 to 7 in the future show, "in X days".
    // When the target date is today, show "Today".
    // For any target dates that are more than 7 days into the future or in the past, show the full date.

    if (differenceInDays < 0 && differenceInDays > -8) {
      _el =
        <TextElStyled className={cssClass} display={display} {...textProps}>
          in {absDifferenceInDays} <FormattedPlural value={absDifferenceInDays} one='day' other='days' />
        </TextElStyled>
    } else if (differenceInDays === 0) {
      _el =
        <TextElStyled className={cssClass} display={display} {...textProps}>
          Today
        </TextElStyled>
    } else {
      _el =
        <TextElStyled className={cssClass} display={display} {...textProps}>
          <OEComponents.DateFormatter
            abbreviateMonth
            date={moment(date).unix()}
            includeTime={false} />
        </TextElStyled>
    }

    return _el
  }
}

TargetDateDueText.defaultProps = {
  styleComponent: P2,
  display: 'inline'
}

TargetDateDueText.propTypes = {
  cssClass: PropTypes.string,
  styleComponent: PropTypes.elementType,
  textProps: PropTypes.object,
  date: PropTypes.string,
  display: PropTypes.string
}
